import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Paper, Container, CircularProgress } from '@material-ui/core';
import { AnalysisInterpretation } from 'types/schema.type';

interface SectionInterpretationProps {
  title: string;
  interpretation: AnalysisInterpretation | null | undefined;
  loading?: boolean;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: 800,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  title: {
    paddingBottom: theme.spacing(1),
  },
  interpretationText: {
    whiteSpace: 'pre-wrap',
    lineHeight: 1.6,
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
  disclaimer: {
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
  },
}));

export function SectionInterpretation({ title, interpretation, loading = false }: SectionInterpretationProps) {
  const classes = useStyles();
  const { t } = useTranslation();

  if (loading) {
    return (
      <Container className={classes.root} component={Paper}>
        <Typography className={classes.title} variant="h6">
          {title}
        </Typography>
        <div className={classes.loadingContainer}>
          <CircularProgress size={24} />
        </div>
      </Container>
    );
  }

  if (!interpretation?.text) {
    return null;
  }

  return (
    <Container className={classes.root} component={Paper}>
      <Typography className={classes.title} variant="h6">
        {title}
      </Typography>
      <Typography variant="body2" className={classes.interpretationText}>
        {interpretation.text}
      </Typography>
      <Typography variant="caption" className={classes.disclaimer}>
        {t('interpretation.aiDisclaimer')}
      </Typography>
    </Container>
  );
}
